import DisplayRichTextString from './DisplayRichTextString.component';

export default DisplayRichTextString;